export const RelativeFilterOptions = {
  Custom: 'Custom',
  InceptionToDate: 'InceptionToDate',
  InceptionToYear: 'InceptionToYear',
  RollingNFiscalYears: 'RollingNFiscalYears',
  RollingNCalenderYears: 'RollingNCalenderYears',
  RollingNFiscalQuarters: 'RollingNFiscalQuarters',
  RollingNCalendarQuarters: 'RollingNCalendarQuarters',
  CurrentFiscalYear: 'CurrentFiscalYear',
  PriorFiscalYear: 'PriorFiscalYear',
  NextFiscalYear: 'NextFiscalYear',
  CurrentAndPriorFiscalYear: 'CurrentAndPriorFiscalYear',
  NextTwoFiscalYear: 'NextTwoFiscalYear',
  PriorTwoFiscalYears: 'PriorTwoFiscalYears',
  CurrentAndPriorTwoFiscalYears: 'CurrentAndPriorTwoFiscalYears',
  CurrentCalendarYear: 'CurrentCalendarYear',
  PriorCalendarYear: 'PriorCalendarYear',
  NextCalendarYear: 'NextCalendarYear',
  CurrentFiscalYearToDate: 'CurrentFiscalYearToDate',
  CurrentFiscalYearToCurrentMonth: 'CurrentFiscalYearToCurrentMonth',
  CurrentFiscalYearToPriorMonth: 'CurrentFiscalYearToPriorMonth',
  PriorFiscalYearToDate: 'PriorFiscalYearToDate',
  CurrentFiscalQuarter: 'CurrentFiscalQuarter',
  CurrentFiscalQuarterToDate: 'CurrentFiscalQuarterToDate',
  PriorFiscalQuarter: 'PriorFiscalQuarter',
  PriorFiscalQuarterToDate: 'PriorFiscalQuarterToDate',
  NextFiscalQuarter: 'NextFiscalQuarter',
  CurrentCalendarYearToDate: 'CurrentCalendarYearToDate',
  PriorCalendarYearToDate: 'PriorCalendarYearToDate',
  CurrentCalendarQuarter: 'CurrentCalendarQuarter',
  CurrentCalendarQuarterToDate: 'CurrentCalendarQuarterToDate',
  PriorCalendarQuarter: 'PriorCalendarQuarter',
  PriorCalendarQuarterToDate: 'PriorCalendarQuarterToDate',
  NextCalendarQuarter: 'NextCalendarQuarter',
  CalendarCalendarMonth: 'CalendarCalendarMonth',
  CurrentMonth: 'CurrentMonth',
  CurrentMonthToDate: 'CurrentMonthToDate',
  PriorMonth: 'PriorMonth',
  PriorMonthToDate: 'PriorMonthToDate',
  NextMonth: 'NextMonth',
  RollingNMonths: 'RollingNMonths',
  InceptionToPeriod: 'InceptionToPeriod',
  CurrentFiscalYearToCurrentPeriod: 'CurrentFiscalYearToCurrentPeriod',
  CurrentFiscalYearToPriorPeriod: 'CurrentFiscalYearToPriorPeriod',
  PriorFiscalYearToCurrentPeriod: 'PriorFiscalYearToCurrentPeriod',
  CurrentFiscalQuarterToCurrentPeriod: 'CurrentFiscalQuarterToCurrentPeriod',
  PriorFiscalQuarterToCurrentPeriod: 'PriorFiscalQuarterToCurrentPeriod',
  CurrentCalendarYearToCurrentPeriod: 'CurrentCalendarYearToCurrentPeriod',
  PriorCalendarYearToCurrentPeriod: 'PriorCalendarYearToCurrentPeriod',
  CurrentCalendarQuarterToCurrentPeriod: 'CurrentCalendarQuarterToCurrentPeriod',
  PriorCalendarQuarterToCurrentPeriod: 'PriorCalendarQuarterToCurrentPeriod',
  InceptionToCurrentMonth: 'InceptionToCurrentMonth',
  CurrentPeriod: 'CurrentPeriod',
  PriorPeriod: 'PriorPeriod',
  PriorYearCurrentPeriod: 'PriorYearCurrentPeriod',
  PriorYearPriorPeriod: 'PriorYearPriorPeriod',
  RollingNPeriods: 'RollingNPeriods'
} as const;

export type FiscalYearOption =
  | 'Current fiscal year'
  | 'PriorFiscalYear'
  | 'NextFiscalYear'
  | 'CurrentAndPriorFiscalYear'
  | 'NextTwoFiscalYear'
  | 'PriorTwoFiscalYears'
  | 'CurrentAndPriorTwoFiscalYears';

type Values<T> = T[keyof T];

export type RelativeFilter = Values<typeof RelativeFilterOptions> | '';

export interface IRollingNumRangeOption {
  label: string;
  value: string;
}

export const isRelativeFilter = (filter: string): filter is RelativeFilter => {
  return Object.values(RelativeFilterOptions).includes(filter as Values<typeof RelativeFilterOptions>);
};
